/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { PlcHttpConfig, PlcHttpConfigToken } from './services.models';

import { ReboundAlphabetSoupRequest } from '../models/rebound-alphabet-soup.request';
import { AlphabetSoup } from '../models/alphabet-soup.entity';
import { FixAlphabetSoupRequest } from '../models/fix-alphabet-soup.request';
import { ReboundAlphabetSoupV2Request } from '../models/rebound-alphabet-soup-v2.request';

export type AlphabetSoupUpdatePathVariables = {
	gameId: string;
	roundId: string;
	soupId: string;
};
export type AlphabetSoupUpdateV3PathVariables = {
	gameId: string;
	roundId: string;
	soupId: string;
};

@Injectable()
export class AlphabetSoupService {
	constructor(
		@Inject(PlcHttpConfigToken) private config: PlcHttpConfig,
		private http: HttpClient,
	) {}

	/**
	 * @deprecated Use updateV3 instead
	 */
	public update(
		path: AlphabetSoupUpdatePathVariables,
		body: ReboundAlphabetSoupRequest,
	): Observable<AlphabetSoup> {
		return this.http.patch<AlphabetSoup>(
			`${this.config.apiUrl}/api/v2/private/games/${path.gameId}/phases/soups/${path.roundId}/soups/${path.soupId}`,
			body,
		);
	}

	public updateV3(
		path: AlphabetSoupUpdateV3PathVariables,
		body: FixAlphabetSoupRequest | ReboundAlphabetSoupV2Request,
	): Observable<AlphabetSoup> {
		return this.http.patch<AlphabetSoup>(
			`${this.config.apiUrl}/api/v3/private/games/${path.gameId}/phases/soups/${path.roundId}/soups/${path.soupId}`,
			body,
		);
	}
}
